import { useFilterAtomValue } from "../../hooks/FilterHooks"
import { usePartnerAtomValue } from "../../hooks/PartnerHooks"
import { LATEST_API_VERSION } from "../../util/Constants"
import { useAtomValue } from "jotai"
import { userAtom } from "../../atoms/user"

export const setQueryParameters = (method = "GET") => {
	const { dateFrom, dateTo, useActivityDate } = useFilterAtomValue()
	const partnerVal = usePartnerAtomValue()
	const user = useAtomValue(userAtom)

	const response = {
		dateFrom: dateFrom,
		dateTo: dateTo,
		useActivityDate: useActivityDate,
		"api-version": LATEST_API_VERSION
	}

	// Only add partner parameter if user is admin AND a partner is selected (non-empty string)
	// This prevents non-admin users from sending partner codes even if manipulated in local storage
	if (user.isAdmin && partnerVal && partnerVal.trim().length > 0) {
		if (method == "POST") {
			response.partnerCodes = partnerVal.split(",")
		} else {
			response.partners = partnerVal
		}
	}

	return response
}
